import { AssetCall } from '../entities/asset-call';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';


export class AssetCallRequest extends BaseRequest {
  
  assetCall : AssetCall;

  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.assetCall = new AssetCall();
  }

}